import { render, staticRenderFns } from "./receiptData.vue?vue&type=template&id=d8b99aa6&scoped=true&"
import script from "./receiptData.vue?vue&type=script&lang=js&"
export * from "./receiptData.vue?vue&type=script&lang=js&"
import style0 from "./receiptData.vue?vue&type=style&index=0&id=d8b99aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b99aa6",
  null
  
)

export default component.exports